/* 获取分享页链接 */
const getShareUrl = function (id) {
  let url = location.origin + '/common-questions/start?id=' + id
  return url
}
const getShareData = function (query = {}) {
  let title = query.que_title.replace(/<\s*br\s*\/*\s*>/g, ',')
  let res = {
    url: query.que_id
      ? location.origin + '/common-questions/start?id=' + query.que_id
      : location.origin + '/common-questions/start',
    desc: query.que_explain || '',
    title: title || '',
    thumbnail: query.que_cover || '' // 分享的缩略图的url
  }
  return res
}

export { getShareUrl, getShareData }
